import { render, staticRenderFns } from "./freeDelivery.vue?vue&type=template&id=6ba7394c&scoped=true"
import script from "./freeDelivery.vue?vue&type=script&lang=js"
export * from "./freeDelivery.vue?vue&type=script&lang=js"
import style0 from "./freeDelivery.vue?vue&type=style&index=0&id=6ba7394c&lang=css"
import style1 from "./freeDelivery.vue?vue&type=style&index=1&id=6ba7394c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba7394c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba7394c')) {
      api.createRecord('6ba7394c', component.options)
    } else {
      api.reload('6ba7394c', component.options)
    }
    module.hot.accept("./freeDelivery.vue?vue&type=template&id=6ba7394c&scoped=true", function () {
      api.rerender('6ba7394c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/components/freeDelivery.vue"
export default component.exports